import React, { useEffect, useState } from 'react'
import { Accordion } from "views/pages/manage/common/commonComponents";
import { advancedPaymentValue, advancePaymentList, paymentModeEyeIcon } from './constant';
import { rowStyle } from './constant';
import { EyeIcon } from 'views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/EyeIcon';
import TribyteVanSFDialog from './paymentDialog/TribyteVanSFDialog';
import { fetchAdvancePaymentDetail, getCoursePricingDetails } from './util';
import ALoader from 'views/pages/manage/common/a-loader';

const AdvancePaymentDetails = ({ currentApplicationDetails={psid:'',applicationId:''} }) => {
  const { psid, applicationId, courseId,businessAreaId, term  } = currentApplicationDetails
  const tableBorder = {
    border: "1px solid #E3E3E3",
    padding: "10px",
    borderRadius: "8px",
  };
  const [advancePaymentDetail, setAdvancePaymentDetail] = useState({})
  const [typeObj, setTypeObj] = useState({})
  const [isOpen, setOpen] = useState(false)
  const [loader, setLoader] = useState(false)
  const [courseEndDate, setCourseEndDate] = useState()
  useEffect(() => {
    getPaymentDetail()
   // getCourseEndDate(courseId, businessAreaDispValue, term)
  }, [applicationId])
  const getPaymentDetail = async (key = 'all') => {
    await fetchAdvancePaymentDetail(key, psid, applicationId, setAdvancePaymentDetail, setLoader)
    const data= await getCoursePricingDetails(courseId, businessAreaId, term,setLoader);
    setCourseEndDate(data?.courseEndDate)
  }

  const handleDialog = (paymentTypeObj = {}) => {

    if (paymentTypeObj?.key === "lumpsum") {
      const url = `${window.location.origin
        }/#/admin/studentCharges/details/${applicationId}/view`;
      // Open the new tab with the constructed URL
      window.open(url, "_blank").focus();
    } else {
      setTypeObj(paymentTypeObj);
      setOpen(true);
    }
  }
  const checkForJodo = (item, advancePaymentDetail) => {
    if (item?.key == 'jodo' && advancePaymentDetail?.[item?.key]?.status != 'ACTIVE')
      return false
    else return true;
  }
  return (loader ? <ALoader position="fixed" /> : <div>
    <Accordion title="Advance Payment Details" titleColor="#262626">
      <div className="mt-3" style={tableBorder}>
        {advancePaymentList.map(item => (
          <div className='mt-3' style={rowStyle}>
            <div className='regular-bolder'>
              {item?.value}
            </div>
            <div className='d-flex align-items-center cursor' style={{ gap: '7px' }}>
              {advancedPaymentValue(item, advancePaymentDetail, currentApplicationDetails, handleDialog)}
              {paymentModeEyeIcon.includes(item?.key) && advancePaymentDetail?.[item?.key]?.status != "N/A" && checkForJodo(item,advancePaymentDetail)&&<span onClick={() => handleDialog(item)}><EyeIcon /></span>}
            </div>

          </div>
        ))}
      </div>
    </Accordion>
    {isOpen && <TribyteVanSFDialog
      psid={psid}
      applicationId={applicationId}
      typeObj={typeObj}
      isOpen={isOpen}
      setOpen={setOpen}
      getPaymentDetail={getPaymentDetail}
      currentApplicationDetails={{...currentApplicationDetails,courseEndDate}}
    />}

  </div>
  );
};


export default AdvancePaymentDetails